var React = require('react');

function Help (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0H42V42H0V0Z","fill":"#4C3371","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21 13C16.584 13 13 16.584 13 21C13 25.416 16.584 29 21 29C25.416 29 29 25.416 29 21C29 16.584 25.416 13 21 13ZM21.8 26.6H20.2V25H21.8V26.6ZM23.456 20.4L22.736 21.136C22.16 21.72 21.8 22.2 21.8 23.4H20.2V23C20.2 22.12 20.56 21.32 21.136 20.736L22.128 19.728C22.424 19.44 22.6 19.04 22.6 18.6C22.6 17.72 21.88 17 21 17C20.12 17 19.4 17.72 19.4 18.6H17.8C17.8 16.832 19.232 15.4 21 15.4C22.768 15.4 24.2 16.832 24.2 18.6C24.2 19.304 23.912 19.944 23.456 20.4Z","fill":"white","key":1})]);
}

Help.defaultProps = {"width":"42","height":"42","viewBox":"0 0 42 42","fill":"none"};

module.exports = Help;

Help.default = Help;
